import beatbumpImg from './_assets/beatbump.jpeg?url';
import svelteLanguageServerWebImg from './_assets/svelte-language-server-web.png?url';
import wolfensvelte3DImg from './_assets/wolfensvelte-3d.png?url';

export type Project = {
	name: string;
	description_short: string;
	note?: {
		text: string;
		link: string;
	};
	github: string;
	image: string;
	tech: {
		icon: 'svelte' | 'typescript' | 'sass' | 'deno' | 'rust' | 'docker';

		name: 'Svelte' | 'TypeScript' | 'SCSS' | 'Deno' | 'Rust' | 'Docker';
	}[];
};

const projects: Project[] = [
	{
		name: 'Beatbump',
		description_short:
			'A privacy-focused YouTube Music frontend that allows you to listen to your music without ads, tracking, or data collection (Not actively maintained).',
		image: beatbumpImg,
		github: 'https://github.com/snuffyDev/Beatbump',
		tech: [
			{ icon: 'svelte', name: 'Svelte' },
			{ icon: 'typescript', name: 'TypeScript' },
			{ icon: 'sass', name: 'SCSS' },
			{ icon: 'deno', name: 'Deno' },
			{ icon: 'rust', name: 'Rust' },
			{ icon: 'docker', name: 'Docker' }
		]
	},
	{
		name: 'Svelte Language Server Web',
		description_short:
			'A complete port of the Node.js-based Svelte Language Server, running entirely in the browser -- no WebAssembly, no Node.js, no BS!',
		image: svelteLanguageServerWebImg,
		github: 'https://github.com/snuffyDev/svelte-language-server-web',
		tech: [{ icon: 'typescript', name: 'TypeScript' }]
	},
	{
		name: 'Wolfensvelte 3D',
		description_short: 'The classic Wolfenstein 3D game, reimagined using only Svelte and the DOM!',
		note: {
			text: 'SvelteHack 2023 Winner',
			link: 'https://hack.sveltesociety.dev/2023/winners'
		},
		image: wolfensvelte3DImg,
		github: 'https://github.com/snuffyDev/Wolfensvelte-3D',
		tech: [
			{ icon: 'svelte', name: 'Svelte' },
			{ icon: 'typescript', name: 'TypeScript' },
			{ icon: 'sass', name: 'SCSS' }
		]
	}
];

export { projects as projectList };
